import { render, staticRenderFns } from "./ResearchArea.vue?vue&type=template&id=e0df6122&scoped=true&"
import script from "./ResearchArea.vue?vue&type=script&lang=ts&"
export * from "./ResearchArea.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchArea.vue?vue&type=style&index=0&id=e0df6122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0df6122",
  null
  
)

export default component.exports